import { isArray } from 'lodash';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mergeOverwrite = (source: any, target: any): any => {
  if (isArray(source) && isArray(target)) {
    return target.reduce((accumulator, value) => {
      const [key] = value.split('|');
      const hasMatch = accumulator.some((item: string) => item.startsWith(key));

      if (!hasMatch) {
        accumulator.push(value);
      }

      return accumulator;
    }, source);
  }

  if (typeof source !== 'object' || typeof target !== 'object') {
    return target || source;
  }

  const base = { ...source };

  Object.entries(target).forEach(([key, value]) => {
    if (typeof value === 'object') {
      base[key] = mergeOverwrite(base[key], value);
    } else {
      base[key] = value;
    }
  });

  return base;
};
